var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductSelection',{attrs:{"product":_vm.selectProduct(_vm.product),"selected":_vm.payload,"limit":_vm.tier.giftsLimit,"tier":_vm.tier,"bundleData":_vm.data},on:{"updateProductVariant":_vm.updateProductVariant,"handleSelectedItem":product => _vm.$emit('handleSelection', product)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }